import * as Klaro from 'klaro/dist/klaro-no-translations-no-css';
import LazyLoad from 'vanilla-lazyload';

import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/core';
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export default {
    init() {

        const homeHeroSwiper = new Swiper('.home-hero__items', {
            spaceBetween: 160,
            fadeEffect: { crossFade: true },
            slidersPerView: 1,
            effect: 'fade',
            speed: 1000,
            pagination: {
                el: '.custom-swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.custom-swiper-button-next',
                prevEl: '.custom-swiper-button-prev',
            },
        })
        homeHeroSwiper;

        const featuredProjectSlider = new Swiper('.featured-projects', {
            slidesPerView: 1,
            spaceBetween: 40,
            speed: 600,
            pagination: {
                el: '.featured-project-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.featured-project-button-next',
                prevEl: '.featured-project-button-prev',
            },
        })
        featuredProjectSlider;

        const latestNewsSlider = new Swiper('.latest-news', {
            slidesPerView: 1,
            spaceBetween: 40,
            speed: 600,
            pagination: {
                el: '.latest-news-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.latest-news-button-next',
                prevEl: '.latest-news-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
            },
        })
        latestNewsSlider;

        const latestEventsSlider = new Swiper('.latest-events', {
            slidesPerView: 1,
            spaceBetween: 40,
            speed: 600,
            pagination: {
                el: '.latest-events-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.latest-events-button-next',
                prevEl: '.latest-events-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 2,
                },
            },
        })
        latestEventsSlider;

        const timelineSlider = new Swiper('.our-timeline__items', {
            slidesPerView: 1,
            spaceBetween: 40,
            speed: 600,
            pagination: {
                el: '.our-timeline-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.our-timeline-button-next',
                prevEl: '.our-timeline-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                },
            },
        })
        timelineSlider;

        const contentSlider = new Swiper('.content-slider__items', {
            slidesPerView: 1,
            spaceBetween: 40,
            speed: 600,
            pagination: {
                el: '.content-slider-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.content-slider-button-next',
                prevEl: '.content-slider-button-prev',
            },
            breakpoints: {
                992: {
                    spaceBetween: 82,
                },
            },
        })
        contentSlider;

        const testimonialSlider = new Swiper('.testimonials__items', {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            autoplay: true,
            speed: 1000,
            pagination: {
                el: '.testimonials-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.testimonials-button-next',
                prevEl: '.testimonials-button-prev',
            },
            breakpoints: {
                992: {
                    spaceBetween: 82,
                },
            },
        })
        testimonialSlider;

        new LazyLoad({
            elements_selector: '.lazyload',
        });

        // JavaScript to be fired on all pages
        window.klaro = Klaro;
        // we set up Klaro with the config
        Klaro.setup(window.klaroConfig);

        // Opening the mobile menu
        $('#menu-button').on('click', function () {
            $('#menu-button').toggleClass('open');
            $( 'body' ).toggleClass( 'mobile-menu-open' );

            var text = $('#menu-button').attr('aria-label');
            if(text == 'Open mobile navigation menu') {
                $('#menu-button').attr('aria-label', 'Close mobile navigation menu')
                $('#menu-button').attr('aria-expanded', true)
            } else {
                $('#menu-button').attr('aria-label', 'Open mobile navigation menu')
                $('#menu-button').attr('aria-expanded', false)
            }
        });
        // Opening the mobile menu

        // Opening the header menu dropdowns
        if ($(window).width() < 992) {
            $('nav .nav--main .menu-item-has-children > a').on('click', function (event) {
                event.preventDefault();
                if( $(this).siblings('ul.sub-menu').find('.mobmenu-back').length === 0 ) {
                    $(this).siblings('ul.sub-menu').prepend('<span class="mobmenu-back">Back a Level</span>');
                }
                $(this).parent().toggleClass('show');
                $(this).next().toggleClass('show');
            });
        } else {
            $('nav .nav--main > .menu-item-has-children > a').on('click', function (event) {
                event.preventDefault();
                if( $(this).siblings('ul.sub-menu').find('.mobmenu-back').length === 0 ) {
                    $(this).siblings('ul.sub-menu').prepend('<span class="mobmenu-back">Back a Level</span>');
                }
                $(this).parent().toggleClass('show');
                $(this).next().toggleClass('show');

                $(this).parent().siblings().removeClass('show');
                $(this).parent().siblings().find('.sub-menu').removeClass('show');
                $(this).next().find('.sub-menu').toggleClass('show');
            });
        }

        $('nav').on('click', '.mobmenu-back', function () {
            $(this).parent().toggleClass('show');
            $(this).next().toggleClass('show');

            $(this).closest('a.dropdown-toggle').toggleClass('show');
            $(this).closest('ul.dropdown-menu').toggleClass('show');
        });
        // Opening the header menu dropdowns

        // Detect elements coming into view and add class
        var observer;
        const ivElements = document.querySelectorAll('.iv');
        observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add('iv-loaded');
                }
            });
        }, { threshold: [0.5] });

        ivElements.forEach(function(image) {
            observer.observe(image);
        });
        // Detect elements coming into view and add class

        $('#accessibility-hide').click(function() {
            $('#pojo-a11y-toolbar').toggleClass('accessibility-hidden');
            $(this).toggleClass('accessibility-hidden');
        });

        $('#pojo-a11y-toolbar').click(function() {
            $('#accessibility-hide').toggleClass('accessibility-open').removeClass('accessibility-hidden');
            $(this).removeClass('accessibility-hidden');
        });

        $('.service-categories__item').on('mouseover', function() {
            $(this).find('.service-categories__overlay').addClass('open');
        });

        $('.service-categories__item').on('mouseout', function() {
            $(this).find('.service-categories__overlay').removeClass('open');
        });

        $('.content-item-list__item').on('mouseover', function() {
            $(this).find('.service-categories__overlay').addClass('open');
        });

        $('.content-item-list__item').on('mouseout', function() {
            $(this).find('.service-categories__overlay').removeClass('open');
        });

        function handleLoadMore(selector, startingAmount) {
            if(window.innerWidth > 992) {
                $(selector).slice(0, startingAmount).show(function(){
                    $(this).css('display', 'flex');
                    if ($(selector + ':hidden').length <= 0) {
                        $('#loadMore').hide();
                    }
                });
            } else {
                $(selector).slice(0, 6).show(function(){
                    $(this).css('display', 'flex');
                    if ($(selector + ':hidden').length <= 0) {
                        $('#loadMore').hide();
                    }
                });
            }
            $('#loadMore').on('click', function (e) {
                e.preventDefault();
                $(selector + ':hidden').slice(0, 2).fadeIn().css('display', 'flex');
                if ($(selector + ':hidden').length <= 0) {
                    $('#loadMore').hide();
                }
            });
        }

        if($('.newsletter-list__item')) {
            handleLoadMore('.newsletter-list__item', 6);
        }

        if($('.events-list__item')) {
            handleLoadMore('.events-list__item', 12);
        }

        $('.header__search-toggle').on('click', function() {
            $('.header__search').toggleClass('active');
        });

        $('.modal-header .close').on('click', function() {
            $('.calendar-modal-wrapper').removeClass('open');
            $('body').removeClass('modal-open');
        });

        if($('.about-us-navigation')) {
            $('.about-us-navigation a.active').each(function() {
                var $this = $(this);
                $this.closest('.accordion-collapse').addClass('show');
                $this.closest('.accordion-item').find('> .accordion-header button').removeClass('collapsed').attr('aria-expanded','true');
                $this.closest('.about-us-navigation__main-item').find('> .accordion-collapse').addClass('show');
                $this.closest('.about-us-navigation__main-item').closest('.accordion-item').find('> .accordion-header button').removeClass('collapsed').attr('aria-expanded','true');
                $this.closest('.about-us-navigation__sub-item').parent().closest('.about-us-navigation__sub-item').find('> .accordion-collapse').addClass('show');
                $this.closest('.about-us-navigation__sub-item').parent().closest('.about-us-navigation__sub-item').find('> .accordion-header button').removeClass('collapsed').attr('aria-expanded','true');
                return false;
            });
            $('.about-us-navigation button.active').each(function() {
                var $this = $(this);
                $this.closest('.accordion-collapse').addClass('show');
                $this.closest('.accordion-item').find('> .accordion-collapse').removeClass('collapse');
                $this.removeClass('collapsed').attr('aria-expanded','true');
                $this.closest('.about-us-navigation__main-item').find('> .accordion-collapse').addClass('show');
                $this.closest('.about-us-navigation__main-item').find('> .accordion-header button').removeClass('collapsed').attr('aria-expanded','true');
                $this.closest('.about-us-navigation__sub-item').find('> .accordion-collapse').addClass('show');
                $this.closest('.about-us-navigation__sub-item').find('> .accordion-header button').removeClass('collapsed').attr('aria-expanded','true');
                $this.closest('.about-us-navigation__sub-item').parent().closest('.about-us-navigation__sub-item').find('> .accordion-collapse').addClass('show');
                $this.closest('.about-us-navigation__sub-item').parent().closest('.about-us-navigation__sub-item').find('> .accordion-header button').removeClass('collapsed').attr('aria-expanded','true');
                return false;
            });
            $('.about-us-navigation button > a').on('click', function(e) {
                e.stopPropagation();
                var senderElement = e.target.href;
                window.location = senderElement;
                return true;
            });

            $( window ).scroll(function() {
                ($(window).scrollTop() >= $('.scroll-marker').offset().top - 100) ? $('.about-us-navigation').addClass('fixed') : $('.about-us-navigation').removeClass('fixed');
            });
        }

        const contactForm = $('._form_1');
        let removeContactFormStylingInterval;

        if (contactForm) {
            removeContactFormStylingInterval = setInterval(removeContactFormStyling, 100);
        }

        function removeContactFormStyling() {
            const $styleElem = $('._form_1 > style');

            if(!$styleElem) {
                return;
            }

            $styleElem.empty();
            clearInterval(removeContactFormStylingInterval);
            removeContactFormStylingInterval = null;

            const $formSubmit = $('._form_1_submit')

            if (!$formSubmit) {
                console.error('no submit button found');
                return;
            }

            $formSubmit.text('Subscribe');
        }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
